import script from "./Start.vue?vue&type=script&setup=true&lang=js"
export * from "./Start.vue?vue&type=script&setup=true&lang=js"

import "./Start.vue?vue&type=style&index=0&id=e7151042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7151042"]])

export default __exports__